<template>
  <div>
    <h1>Lista de Parceiros</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'parceiros_create' }"
            v-if="$can('parceiro:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table
        striped
        hover
        :items="parceiros"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(endereco)="{ item }">
          <CellEndereco :endereco="item.pessoa_juridica.endereco" />
        </template>
        <template #cell(contatos)="{ item }">
          <CellContatos :contatos="item.pessoa_juridica.contatos" />
        </template>

        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('parceiro:edit')"
            :view_delete="$can('parceiro:delete')"
            edit_to="parceiros_edit"
            @delete="deleteItem"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  mixins: [mixins],
  computed: {
    ...mapState("parceiros", ["parceiros", "pagination"]),
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1", sortable: true },
        {
          key: "pessoa_juridica",
          label: "nome",
          sortable: true,
          formatter: (value) => {
            return value.nome;
          },
        },
        { key: "endereco", label: "Endereço" },
        { key: "contatos", label: "Contatos" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("parceiros", ["ActionGetAll", "ActionDelete"]),
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>

<style></style>
